import React, { useMemo, useState } from 'react'
import { useTable, useExpanded } from 'react-table'
import MOCK_DATA from './MOCK_DATA.json'
import { COLUMNS } from './columns'

export default function WishListForm() {
    const columns = useMemo(() => COLUMNS, [])
    const data = useMemo(() => MOCK_DATA, [])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        visibleColumns,
        state: { expanded },
    } = useTable(
        {
            columns,
            data,
        },
        useExpanded // We can useExpanded to track the expanded state
        // for sub components too!
    )

    const [inputValue, setInputValue] = useState()
    const inputOnchangeHandle = (e) => {
        console.log(e.target.value)
    }

    
    return (
        <>
            <div className='shippingTable'>
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row)
                            return (
                                // Use a React.Fragment here so the table markup is still valid
                                <React.Fragment {...row.getRowProps()}>
                                    <tr>
                                        {row.cells.map(cell => {
                                            return (
                                                <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                            )
                                        })}
                                    </tr>
                                    {/*
                      If the row is in an expanded state, render a row with a
                      column that fills the entire length of the table.
                    */}
                                    {row.isExpanded ? (
                                        row.original.testForSubComponent.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td colSpan={visibleColumns.length}>
                                                        {/*
                            Inside it, call our renderRowSubComponent function. In reality,
                            you could pass whatever you want as props to
                            a component like this, including the entire
                            table instance. But for this example, we'll just
                            pass the row
                          */}
                                                        {/*{renderRowSubComponent({ row })}*/}
                                                        {console.log(row)}
                                                        {item}
                                                        <input className='customerFormEditableInput'
                                                        defaultValue={item}
                                                            //value={inputValue || item}
                                                        onChange={(e) => {inputOnchangeHandle(e)}}
                                                        type="search"
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        })

                                    ) : null}
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}